import React from "react";

const InvitationSkeleton: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 animate-pulse">
    <div className="max-w-md w-full space-y-8">
      {/* heading */}
      <div className="text-center">
        <div className="h-8 bg-gray-200 rounded w-3/4 mx-auto mb-3" />
        <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto" />
      </div>
      {/* card */}
      <div className="bg-white shadow-lg rounded-lg p-8 space-y-6">
        {/* info box */}
        <div className="bg-blue-50 rounded-lg p-4 space-y-2">
          <div className="h-3 bg-blue-100 rounded w-1/2" />
          <div className="h-3 bg-blue-100 rounded w-1/3" />
        </div>
        {/* form fields */}
        {[...Array(2)].map((_, i) => (
          <div key={i} className="space-y-1">
            <div className="h-3 bg-gray-200 rounded w-20 mb-2" />
            <div className="h-10 bg-gray-200 rounded-md" />
          </div>
        ))}
        {/* button */}
        <div className="h-10 bg-gray-200 rounded-md" />
      </div>
    </div>
  </div>
);

export default InvitationSkeleton;
